import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { Formik } from 'formik'
import { gql, useApolloClient, useMutation } from '@apollo/client'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlusIcon } from '@10xLabs/react-web/components/Icons/Plus'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TrashOIcon } from '@10xLabs/react-web/components/Icons/TrashO'
import { Button } from 'components/v2/Button'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Input } from 'components/Input'
import { InputCurrency } from 'components/InputCurrency'
import { Switch } from 'components/v2/Switch'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { getTaxonomyByFare, getFareByTaxonomy, resolvers as faresResolvers } from 'resolvers/fares'
import { sanitizePrice } from 'utils/math'
import { getUnprocessableErrors } from 'utils/error'
import { canWrite } from 'features/Users/utils'
import { schema } from './schema'
import { useLogin } from 'features/Login/hooks'

const StyledTd = styled(Td)<TSFixMe>`
  input {
    width: calc(100% - 20px);
    min-width: ${(props): TSFixMe => (props.largeInput ? '84px' : '50px')};
    max-width: 100px;
  }

  ${({ isShowingOldDesign }): TSFixMe => {
    if (isShowingOldDesign) {
      return `
        input,
        select {
          padding: 7px 9px;
          font-size: 14px;
        }
      `
    }
  }}
`

const Footer = styled.div<TSFixMe>`
  margin: 20px 0 0;
`

const Actions = styled.div<TSFixMe>`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ErrorMessageWrapper = styled.div<TSFixMe>`
  text-align: right;
`

const SecondaryInfo = styled.div<TSFixMe>`
  font-size: 13px;
  color: #9999bd;
  white-space: nowrap;
`

const AddAction = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #916ee8;
  font-size: 16px;

  svg {
    margin-right: 7px;
    fill: #916ee8;
    width: 18px;
    height: 18px;
  }
`

const TrashWrapper = styled.div<TSFixMe>`
  display: flex;
  cursor: pointer;
`

const StyledTrashOIcon = styled(TrashOIcon)<TSFixMe>`
  fill: #1976d2;
  width: 18px;
  height: 22px;
`

const CHANGE_FARES = gql`
  mutation ChangeFareFamilyFares($input: changeFareFamilyFaresInput!) {
    changeFareFamilyFares(input: $input)
  }
`

const ADD_FARES = gql`
  mutation AddFareFamilyFares($input: AddFareFamilyFaresInput!) {
    addFareFamilyFares(input: $input) {
      fareIDs
    }
  }
`

const UPDATE_LOCAL_FARE_FAMILY = gql`
  mutation UpdateFamilyFare($fareFamily: FareFamiy) {
    updateFamilyFare(fareFamily: $fareFamily) @client
  }
`

export const FaresList = ({ fareFamily, fares = [], bookingClasses = [] }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const client = useApolloClient()
  client.addResolvers(faresResolvers)

  const [updatedFares, setUpdatedFares] = useState()
  const [addedFares, setAddedFares] = useState()

  const login = useLogin()
  const [updateLocalFareFamily] = useMutation(UPDATE_LOCAL_FARE_FAMILY)
  const [changeFares, { loading: changeFaresLoading, error: changeFaresError }] = useMutation(CHANGE_FARES, {
    onCompleted() {
      const now = new Date()

      updateLocalFareFamily({
        variables: {
          fareFamily: {
            ...fareFamily,
            fares: fareFamily.fares.map((fare: TSFixMe): TSFixMe => {
              const updatedFare = // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                updatedFares.find(({ id }: TSFixMe): TSFixMe => id === fare.id)

              if (updatedFare) {
                return {
                  ...fare,
                  basePrice: updatedFare.basePrice,
                  isActive: updatedFare.isActive,
                  updatedAt: now
                }
              }

              return fare
            })
          }
        }
      })
    }
  })
  const [addFares, { loading: addFaresLoading, error: addfaresError }] = useMutation(ADD_FARES, {
    onCompleted(data) {
      const fareIds = data.addFareFamilyFares.fareIDs
      const now = new Date()

      updateLocalFareFamily({
        variables: {
          fareFamily: {
            ...fareFamily,
            fares: [
              ...fareFamily.fares,
              ...// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
              addedFares.map((fare: TSFixMe, index: TSFixMe): TSFixMe => {
                return {
                  id: fareIds[index],
                  bookingClass: {
                    id: fare.bookingClass.id,
                    name: fare.bookingClass.name,
                    __typename: 'FareFamilyFareBookingClass'
                  },
                  seasonType: fare.seasonType,
                  serviceType: fare.serviceType,
                  type: fare.type,
                  timeWindow: fare.timeWindow,
                  dow: fare.dow,
                  demand: fare.demand,
                  salesChannel: fare.salesChannel,
                  basePrice: fare.basePrice,
                  isActive: fare.isActive,
                  createdAt: now,
                  updatedAt: now,
                  __typename: 'FareFamilyFare'
                }
              })
            ]
          }
        }
      })
    }
  })

  const getUpdatedFares = (fares: TSFixMe): TSFixMe => {
    return fares
      .filter((fare: TSFixMe): TSFixMe => {
        if (fare.id) {
          const oldFare = fareFamily.fares.find(({ id }: TSFixMe): TSFixMe => id === fare.id)

          if (oldFare) {
            const newBasePrice = sanitizePrice(fare.basePrice * 100, true)

            return oldFare.basePrice !== newBasePrice || oldFare.isActive !== fare.isActive
          }
        }
        return false
      })
      .map((fare: TSFixMe): TSFixMe => {
        return {
          id: fare.id,
          basePrice: sanitizePrice(fare.basePrice * 100, true),
          isActive: fare.isActive
        }
      })
  }

  const updateFares = (values: TSFixMe): TSFixMe => {
    const updatedFares = getUpdatedFares(values.fares)

    if (updatedFares.length > 0) {
      setUpdatedFares(updatedFares)

      changeFares({
        variables: {
          input: {
            id: fareFamily.id,
            fares: updatedFares
          }
        }
      })
    }
  }

  const getAddedFares = (fares: TSFixMe): TSFixMe => {
    return fares.filter((fare: TSFixMe): TSFixMe => !fare.id)
  }

  const addNewFares = (values: TSFixMe): TSFixMe => {
    const addedFares = getAddedFares(values.fares)

    if (addedFares.length > 0) {
      setAddedFares(
        addedFares.map((fare: TSFixMe): TSFixMe => {
          return {
            bookingClass: fare.bookingClass,
            seasonType: fare.seasonType,
            type: fare.type,
            timeWindow: fare.timeWindow,
            dow: fare.dow,
            demand: fare.demand,
            salesChannel: fare.salesChannel,
            serviceType: fare.serviceType,
            basePrice: sanitizePrice(fare.basePrice * 100, true),
            isActive: fare.isActive
          }
        })
      )

      addFares({
        variables: {
          input: {
            id: fareFamily.id,
            fares: addedFares.map((fare: TSFixMe): TSFixMe => {
              return {
                bookingClassID: fare.bookingClass.id,
                seasonType: fare.seasonType,
                type: fare.type,
                timeWindow: fare.timeWindow,
                dow: fare.dow,
                demand: fare.demand,
                salesChannel: fare.salesChannel,
                serviceType: fare.serviceType,
                basePrice: sanitizePrice(fare.basePrice * 100, true),
                isActive: fare.isActive
              }
            })
          }
        }
      })
    }
  }

  const onSubmit = (values: TSFixMe): TSFixMe => {
    updateFares(values)

    addNewFares(values)
  }

  const initialFareFamily = {
    id: fareFamily.id,
    fares: fares.map((fare: TSFixMe): TSFixMe => {
      return {
        ...fare,
        taxonomy: getTaxonomyByFare(fare, fareFamily.familyName),
        basePrice: sanitizePrice(fare.basePrice / 100),
        isTaxonomyDisabled: true
      }
    })
  }

  return (
    <Formik initialValues={initialFareFamily} validationSchema={schema(intl)} onSubmit={onSubmit} enableReinitialize>
      {(props): TSFixMe => {
        const { handleSubmit, setFieldValue, setFieldTouched, handleBlur, values, touched, errors } = props

        const handleAddFare = (): TSFixMe => {
          const newFares = [
            ...values.fares,
            {
              taxonomy: '',
              ...getFareByTaxonomy('', bookingClasses),
              basePrice: '',
              isActive: true
            }
          ]
          setFieldValue('fares', newFares)
        }

        const getUpdatedFaresCount = (): TSFixMe => {
          const updatedFares = getUpdatedFares(values.fares)
          const addedFares = getAddedFares(values.fares)

          return updatedFares.length + addedFares.length
        }

        const updatedCount = getUpdatedFaresCount()

        return (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.taxonomy" defaultMessage="Taxonomy" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.total" defaultMessage="Total" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.created" defaultMessage="Created" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.updated" defaultMessage="Updated" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.status" defaultMessage="Status" />
                    </Th>
                    <Th />
                  </Tr>
                </Thead>
                <Tbody>
                  {values.fares.map((fare: TSFixMe, index: TSFixMe): TSFixMe => {
                    const handleTaxonomyChange = ({ target: { value } }: TSFixMe): TSFixMe => {
                      value = value.toUpperCase()
                      setFieldValue(`fares[${index}]`, {
                        ...fare,
                        taxonomy: value,
                        ...getFareByTaxonomy(value, bookingClasses)
                      })
                    }

                    const handleTaxonomyBlur = (): TSFixMe => {
                      setFieldTouched(`fares[${index}].bookingClass.id`, true)
                      setFieldTouched(`fares[${index}].type`, true)
                      setFieldTouched(`fares[${index}].seasonType`, true)
                      setFieldTouched(`fares[${index}].timeWindow`, true)
                      setFieldTouched(`fares[${index}].dow`, true)
                      setFieldTouched(`fares[${index}].demand`, true)
                      setFieldTouched(`fares[${index}].salesChannel`, true)
                      setFieldTouched(`fares[${index}].serviceType`, true)
                    }

                    const handleDeleteFare = (): TSFixMe => {
                      const newFares = values.fares.filter(
                        (fare: TSFixMe, fareIndex: TSFixMe): TSFixMe => fareIndex !== index
                      )

                      setFieldValue('fares', newFares)
                    }

                    const isTaxonomyTouched =
                      touched.fares && // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                      touched.fares[index]?.type
                    const taxonomyErrors =
                      errors.fares &&
                      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                      errors.fares[index] && // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                      ((errors.fares[index].bookingClass && errors.fares[index].bookingClass.id) ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].type ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].seasonType ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].timeWindow ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].dow ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].demand ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].salesChannel ||
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        errors.fares[index].serviceType)

                    return (
                      <Tr key={index}>
                        <StyledTd largeInput>
                          <Input
                            id={`fares[${index}].taxonomy`}
                            onChange={handleTaxonomyChange}
                            onBlur={handleTaxonomyBlur}
                            value={fare.taxonomy}
                            readOnly={fare.isTaxonomyDisabled}
                            touched={isTaxonomyTouched}
                            errors={taxonomyErrors}
                            small
                          />
                        </StyledTd>
                        <StyledTd>
                          <InputCurrency
                            id={`fares[${index}].basePrice`}
                            value={sanitizePrice(fare.basePrice)}
                            placeholder="$0.00"
                            onChange={(value): TSFixMe => {
                              setFieldValue(`fares[${index}].basePrice`, value)
                            }}
                            onBlur={handleBlur}
                            touched={
                              touched.fares && // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                              touched.fares[index]?.basePrice
                            }
                            errors={
                              errors.fares && // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                              errors.fares[index]?.basePrice
                            }
                            hideSuffix
                            readOnly={!canWrite(FEATURES.FARE_FAMILY, login.accessToken.policies)}
                            small
                          />
                        </StyledTd>
                        <Td>
                          {fare.createdAt && (
                            <>
                              <FormattedDate
                                intl={intl}
                                value={fare.createdAt}
                                month="2-digit"
                                day="2-digit"
                                year="numeric"
                              />
                              <SecondaryInfo>
                                <FormattedTimeByDate intl={intl} date={fare.createdAt} />
                              </SecondaryInfo>
                            </>
                          )}
                        </Td>
                        <Td>
                          {fare.updatedAt && (
                            <>
                              <FormattedDate
                                intl={intl}
                                value={fare.updatedAt}
                                month="2-digit"
                                day="2-digit"
                                year="numeric"
                              />
                              <SecondaryInfo>
                                <FormattedTimeByDate intl={intl} date={fare.updatedAt} />
                              </SecondaryInfo>
                            </>
                          )}
                        </Td>
                        <Td>
                          <Switch
                            value={fare.isActive}
                            onChange={(value): TSFixMe => {
                              if (canWrite(FEATURES.FARE_FAMILY, login.accessToken.policies)) {
                                setFieldValue(`fares[${index}].isActive`, value)
                              }
                            }}
                          />
                        </Td>
                        <Td>
                          {!fare.isTaxonomyDisabled && (
                            <TrashWrapper onClick={handleDeleteFare}>
                              <StyledTrashOIcon />
                            </TrashWrapper>
                          )}
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
            <Footer>
              {(addfaresError || changeFaresError) && (
                <ErrorMessageWrapper>
                  <ErrorMessage
                    errors={[...getUnprocessableErrors(addfaresError), ...getUnprocessableErrors(changeFaresError)]}
                  >
                    <FormattedMessage
                      id="fareFamilies.fares.form.error"
                      defaultMessage="There was an error while updating your fare family"
                    />
                  </ErrorMessage>
                </ErrorMessageWrapper>
              )}
              {canWrite(FEATURES.FARE_FAMILY, login.accessToken.policies) && (
                <Actions>
                  <div>
                    <AddAction onClick={handleAddFare}>
                      <PlusIcon />
                      <FormattedMessage id="dictionary.add" defaultMessage="Add" />
                    </AddAction>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      kind="primary"
                      loading={addFaresLoading || changeFaresLoading}
                      disabled={updatedCount === 0}
                    >
                      {updatedCount > 0 ? (
                        <FormattedMessage
                          id="fareFamilies.fares.form.submit"
                          defaultMessage="Update ({count})"
                          values={{
                            count: updatedCount
                          }}
                        />
                      ) : (
                        <FormattedMessage
                          id="dictionary.update"
                          defaultMessage="Update"
                          values={{
                            count: updatedCount
                          }}
                        />
                      )}
                    </Button>
                  </div>
                </Actions>
              )}
            </Footer>
          </form>
        )
      }}
    </Formik>
  )
}
